import axios from './configAxios';

export const delUser = async (adressId) => {
  return axios.delete(`/${adressId}/delete/`);
};